import { Tooltip } from 'antd';
import React from 'react';
import useCompanies from '../../../../../queries/useCompanies';
import useTransportPermitsMatch from '../../hooks/useTransportPermitsMatch';
import DropdownSelect from '../../../../../components/dropdownSelect';
import { useHistory, useLocation } from 'react-router-dom';
import { links } from '../../constants/links';
import { getControlComponent } from '../../lib/getControlComponent';
import { saveSelectedCompanyId } from '../../../../../helpers/companyStorage';

const getOptions = (data = []) => {
  if (!data || !data?.length) return [];

  return data?.map((item) => ({
    ...item,
    value: item.id,
    key: item.id,
    search: item.name || String(item.id),
    content: item.name || String(item.id),
  }));
};

const CompanySelect = () => {
  const { data: companies, isFetching } = useCompanies();
  const { search } = useLocation();

  const history = useHistory();

  const match = useTransportPermitsMatch();

  const urlCompanyId = match?.params.companyId
    ? Number(match.params.companyId)
    : null;

  const isDisabled = isFetching || companies?.length === 1;

  const handleChange = (companyId) => {
    if (companyId !== urlCompanyId) {
      saveSelectedCompanyId(companyId);

      history.push({
        pathname: `${links.rootWithCompany}/${companyId}/${match?.params.page}`,
        search,
      });
    }
  };

  return (
    <div style={{ width: 320 }}>
      <Tooltip>
        <DropdownSelect
          options={getOptions(companies)}
          value={urlCompanyId}
          disabled={isDisabled}
          loading={isFetching}
          multiple={false}
          renderControl={getControlComponent({
            options: getOptions(companies),
            value: urlCompanyId,
            disabled: isDisabled,
            loading: isFetching,
          })}
          onChange={handleChange}
        />
      </Tooltip>
    </div>
  );
};

export default CompanySelect;
